import JadwalKelas from "@/modules/pembayaran/components/JadwalKelas";
import JadwalKelasForm from "@/modules/pembayaran/components/JadwalKelasForm";

import KatalogTiket from "@/modules/pembayaran/components/KatalogTiket";
import KatalogTiketForm from "@/modules/pembayaran/components/KatalogTiketForm";

import ListTransaction from "@/modules/pembayaran/components/ListTransaction";

import MetodePembayaran from "@/modules/pembayaran/components/MetodePembayaran";
import MetodePembayaranForm from "@/modules/pembayaran/components/MetodePembayaranForm";

import Pembayaran from "@/modules/pembayaran/components/Pembayaran";
import PembayaranDetail from "@/modules/pembayaran/components/PembayaranDetail";

import Produk from "@/modules/pembayaran/components/Produk";
import ProdukForm from "@/modules/pembayaran/components/ProdukForm";

import ReferralCode from "@/modules/pembayaran/components/ReferralCode";
import ReferralCodeDetail from "@/modules/pembayaran/components/ReferralCodeDetail";

import Testimoni from "../components/Testimoni.vue";
import TestimoniForm from "../components/TestimoniForm.vue";

import TicketUsage from "@/modules/pembayaran/components/TicketUsage";
import TicketUsageDetail from "@/modules/pembayaran/components/TicketUsageDetail";

import Transaksi from "@/modules/pembayaran/components/transaksi/Transaksi";
import TransaksiForm from "@/modules/pembayaran/components/transaksi/Form";

import VoucherCode from "@/modules/pembayaran/components/VoucherCode";
import VoucherCodeForm from "@/modules/pembayaran/components/VoucherCodeForm";
import VoucherCodeDetail from "@/modules/pembayaran/components/VoucherCodeDetail";

export default [
    {
        path: "/pembayaran",
        name: "Pembayaran",
        component: Pembayaran,
    },
    {
        path: "/pembayaran/detail",
        name: "PembayaranDetail",
        component: PembayaranDetail,
    },
    {
        path: "/metode-pembayaran",
        name: "MetodePembayaran",
        component: MetodePembayaran,
    },
    {
        path: "/metode-pembayaran/form",
        name: "MetodePembayaranForm",
        component: MetodePembayaranForm,
    },
    {
        path: "/produk",
        name: "Produk",
        component: Produk,
    },
    {
        path: "/produk/form",
        name: "ProdukForm",
        component: ProdukForm,
    },
    {
        path: "/transaksi",
        name: "Transaksi",
        component: Transaksi,
    },
    {
        path: "/transaksi/form",
        name: "TransaksiForm",
        component: TransaksiForm,
    },
    {
        path: "/testimoni",
        name: "Testimoni",
        component: Testimoni,
    },
    {
        path: "/testimoni/form",
        name: "TestimoniForm",
        component: TestimoniForm,
    },
    {
        path: "/jadwal-kelas",
        name: "JadwalKelas",
        component: JadwalKelas,
    },
    {
        path: "/jadwal-kelas/form",
        name: "JadwalKelasForm",
        component: JadwalKelasForm,
    },
    {
        path: "/ticket-usage",
        name: "TicketUsage",
        component: TicketUsage,
    },
    {
        path: "/ticket-usage/detail",
        name: "TicketUsageDetail",
        component: TicketUsageDetail,
    },
    {
        path: "/katalog-tiket",
        name: "KatalogTiket",
        component: KatalogTiket,
    },
    {
        path: "/katalog-tiket/form",
        name: "KatalogTiketForm",
        component: KatalogTiketForm,
    },
    {
        path: "/produk/list-transaction",
        name: "ListTransaction",
        component: ListTransaction,
    },
    {
        path: "/referral-code",
        name: "ReferralCode",
        component: ReferralCode,
    },
    {
        path: "/referral-code-detail",
        name: "ReferralCodeDetail",
        component: ReferralCodeDetail,
    },
];



// WEBPACK FOOTER //
// ./src/modules/pembayaran/router/pembayaran.js